import { Injectable } from '@angular/core';

import { DomainsRepository } from '../domain/domains.repository';
import { CreateDomainInput, Domain } from '../models/domain.model';
import { DOMAIN_COLORS } from '../models/domain-color.model';

@Injectable({ providedIn: 'root' })
export class DomainsService {
  constructor(private readonly repository: DomainsRepository) {}

  getDomains(): Promise<Domain[]> {
    return this.repository.getDomains();
  }

  createDomain(input: CreateDomainInput): Promise<Domain> {
    return this.repository.createDomain(this.normalizeInput(input));
  }

  updateDomain(id: number, input: CreateDomainInput): Promise<Domain> {
    return this.repository.updateDomain(id, this.normalizeInput(input));
  }

  setDomainArchived(id: number, archived: boolean): Promise<void> {
    return this.repository.setDomainArchived(id, archived);
  }

  setShortcutVisible(id: number, visible: boolean): Promise<void> {
    return this.repository.setShortcutVisible(id, visible);
  }

  deleteDomain(id: number): Promise<void> {
    return this.repository.deleteDomain(id);
  }

  private normalizeInput(input: CreateDomainInput): CreateDomainInput {
    const name = input.name.trim();
    const color = input.color;

    if (!name) throw new Error('Le nom du domaine est obligatoire.');
    if (name.length > 120) throw new Error('Le nom du domaine ne peut pas dépasser 120 caractères.');
    if (!DOMAIN_COLORS.includes(color)) throw new Error('La couleur du domaine est invalide.');

    return { name, color };
  }
}
